import { schema } from 'normalizr';

export const labelReviewItemSchema = new schema.Entity('labelReviewItems', {}, { idAttribute: 'LabelReviewItemId' });
export const labelReviewItemListSchema = [labelReviewItemSchema];
